import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { T } from "react-translator-component";
import appServices from "../../../../services/app-services/appServices";
import QrReader from "../../../../components/QrReader";
import LoadingModal from "../../../../components/LoadingModal";
import GCBackButton from "../../../../components/GreenCity/GCBackButton";
import "../../../../components/qr.css";
import { isClosedGroup } from "../../../../util/utils";

const ScanGroupQr = () => {
  const navigate = useNavigate();
  const refCameraQrArea = useRef<HTMLDivElement>(null!);
  const [scanedCode, setScanedCode] = useState<string>("");
  const [loading, setLoading] = useState(false);

  // 初回実行
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // QRコードを読み込んだとき
  useEffect(() => {
    handleQr(scanedCode)
  }, [scanedCode]);

  const handleQr = async (scanedCode: string) => {
    if (scanedCode === undefined || scanedCode === null || scanedCode === "") return;

    const targetGroupId = scanedCode.split('/groupinvitation?link=')[1];

    if (!targetGroupId) return;

    setLoading(true)
    try {
      const response = await appServices.getMembersGroup(Number(targetGroupId));
      if (!isClosedGroup(response?.member_group.closed_at)) {
        navigate("/groupinforeview", {state: {groupId: Number(targetGroupId)}});
        return
      }
      // 参加可能なグループではない場合
      setScanedCode("")
    } catch (error) {
      //pass
    } finally {
      setLoading(false)
    }
  };

  return (
    <div style={{ paddingTop: 100, marginLeft: 16, height: '100vh' }}>
      <GCBackButton onClick={() => navigate(-1)} />
      <LoadingModal visible={loading} />

      {/* QR Scanner */}
      <div className="qr-reader">
        <div style={{
          fontSize: 16,
          paddingTop: 30,
          lineHeight: "25px",
          letterSpacing: 1
        }}>
          {T("scan_group_qr_read_qr")}
        </div>
        <div style={{
          fontSize: 16,
          paddingTop: 28,
          lineHeight: "25px",
          letterSpacing: 1
        }}>
          {T("scan_group_qr_description")}
        </div>
        <div ref={refCameraQrArea} style={{marginTop: 20}}>
          <div className="camera-container">
            <QrReader
              scanedCode={scanedCode}
              setScanedCode={setScanedCode}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScanGroupQr;
